/**
 * Utilities for working with pointer interactions.
 */

type PointerCarrier = {
  pointerType?: unknown;
};

type NativePointerCarrier = {
  nativeEvent?: unknown;
};

function readPointerType(source: unknown): string | null | undefined {
  if (!source || typeof source !== 'object') {
    return;
  }

  const pointerType = (source as PointerCarrier).pointerType;
  if (typeof pointerType === 'string' || pointerType === null) {
    return pointerType;
  }

  const nativeEvent = (source as NativePointerCarrier).nativeEvent;
  if (nativeEvent && typeof nativeEvent === 'object') {
    const nativePointerType = (nativeEvent as PointerCarrier).pointerType;
    if (typeof nativePointerType === 'string' || nativePointerType === null) {
      return nativePointerType;
    }
  }

  return;
}

/**
 * Returns whether the pointer associated with the provided event or pointer type is coarse
 * (typically touch or stylus input).
 */
export function isCoarsePointerInteraction(source?: unknown): boolean {
  const pointerType = readPointerType(source);
  if (typeof pointerType === 'string') {
    return pointerType === 'touch' || pointerType === 'pen';
  }

  if (globalThis.window !== undefined && typeof globalThis.matchMedia === 'function') {
    return globalThis.matchMedia('(pointer: coarse)').matches;
  }

  return false;
}

/**
 * Extracts the pointer type string from the provided event-like object, if available.
 */
export function getPointerType(source?: unknown): string | null | undefined {
  return readPointerType(source);
}
